import { Insurer } from "./insurer.model";
import { Product } from "./product.model";
import { StatusPolicyCheck } from "./status-policy-check";

export class TravelInsurance {
  id: string;
  lastName: string;
  initials: string;
  policyNumber: string;
  policyHolderStreet: string;
  policyHolderHouseNumber: string;
  policyHolderHouseNumberAddOn: string;
  policyHolderCity: string;
  policyHolderZipCode: string;
  policyHolderCountryCode: string;
  policyHolderLastName: string;
  productCode: string;
  productType: string;
  productName: any;
  productId: string;
  prodCode: string
  insurerNumber: string;
  insurerId: string;
  arrangedBy: any;
  familyComposition: string;
  coverageArea: string;
  policyDetails: string;
  expiryDate: Date;
  ptiReferenceDate: Date;
  ptiStatusPolicyCheck: StatusPolicyCheck;
  ptiTypePolicyCheck: string;
  policyOverview: string;
  ptiIntermediary: string;
  ptiTravelAgency: string;
  ptiMandatePhoneNumber: string;
  ptiInsurerPhoneNumber: string;
  ptiIntermediaryPhoneNumber: string;
  ptiTravelAgencyPhoneNumber: string;
  ptiComment: string;
  ptiIsManual: boolean;
  isSelected: boolean;
  ptiPolicyHolder: string;
  insurer: any;
  ptiAlarmcenter: string;
  ptiMandate: any;
  mandateNumber: string;
  isReaInsuranceType: boolean;
  fellowTravellerId: string;
  policyHolderInitials: string;
  medicalcosts: boolean = false  ;
  skiing : boolean = false ;
  crosscountryskiing : boolean= false ;
  worldcoverage : boolean= false ;
  europeancoverage : boolean= false ;
  specialsports : boolean= false ;
  other : boolean = false ;
  carassistance  : boolean= false ;
  isSOSClient : any;
  policyCommencementDate: Date;
  otherAlarmcenter: string;
  policyCheckDate: Date;
  personName: string;
  ptiClient:any;
  ptiMAlarmcenter:any;
  ptiChargedExpenses:any;
  ptiServiceFees:any;
  assignmentId:string = null;
  ptiInvolvedPartyId: any;
  ptiInvolvedParty: any;
  involvedPartyId: string = null ;
  involvedParty: any;
  coveredPerson  : string = null ;
  ptiBeginTravelDate: Date;
  ptiReturnDate: Date;
  product:Product;
  ptiInsurer : Insurer;
  coverageDetails : string;
  mandate : string;
  referenceDate: Date;
  typePolicyCheck: string;
  statusPolicyCheck : number;
}
